import {BaseFormModel} from './base-form-model';
import {MenuModifierGroup} from './menu-modifier-group';

export class MenuToppingModifierGroup extends BaseFormModel<MenuToppingModifierGroup> {
    id: number;
    menuModifierGroup: MenuModifierGroup;
    sortOrder: number;
}
